import {ImageData} from "./Image";
import {PersonBetter} from "./Person"
import {ShoeboxLocation} from "./Location";

export enum DateFormat {
    DAY = 'day',
    MONTH = 'month',
    YEAR = 'year',
}

export interface EventData {
    key: string;
    images: ImageData[];
    title?: string;
    location_description?: string;  // General location name (e.g., "Home", "School")
    location?: ShoeboxLocation;    // Structured location data with geolocation
    date?: Date;
    dateFormat?: DateFormat;
    keywords?: string[];
    attendees?: PersonBetter[];
}